import './App.css';
import './index.css';

export function Technology() {
  return (
    <>
      <div className='tech'>
        <h1 className='title'>Technology</h1>
      </div>
      <div className="streetlight">
        <h2 className='heading'>Streetlight</h2>
        <p>Streetlight was a video app for real estate entitlements, allowing residents to support new housing by recording videos.</p>
        <p>Try it out <a target='_blank' href="https://streetlight.app/projects/b05730db0bd0a10e">here</a>.</p>
        <p>Built with Javascript, HTML, CSS, and Node.js.</p>
      </div>
      
    </>
  )
}